"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'remote-item-edit/';
exports.default = {
  ADD_INIT: _DOMAIN + 'ADD_INIT',
  ADD_SUCCESS: _DOMAIN + 'ADD_SUCCESS',
  ADD_FAILURE: _DOMAIN + 'ADD_FAILURE',
  EDIT_INIT: _DOMAIN + 'EDIT_INIT',
  EDIT_SUCCESS: _DOMAIN + 'EDIT_SUCCESS',
  EDIT_FAILURE: _DOMAIN + 'EDIT_FAILURE',
  CONTRIBUTE_INIT: _DOMAIN + 'CONTRIBUTE_INIT',
  CONTRIBUTE_SUCCESS: _DOMAIN + 'CONTRIBUTE_SUCCESS',
  CONTRIBUTE_FAILURE: _DOMAIN + 'CONTRIBUTE_FAILURE',
  ON_GROUP_UPDATE: _DOMAIN + 'ON_GROUP_UPDATE',
  FETCH_ITEMS_INIT: _DOMAIN + 'FETCH_ITEMS_INIT',
  FETCH_ITEMS_SUCCESS: _DOMAIN + 'FETCH_ITEMS_SUCCESS',
  FETCH_ITEMS_FAILURE: _DOMAIN + 'FETCH_ITEMS_FAILURE',
  CLEAR: _DOMAIN + 'CLEAR'
};